// src/App.js
import React from 'react';
import AppRoutes from './routes';
import './App.css';
import { NavigationProvider } from './components/NavigationContext';
import { InactivityProvider } from "./components/InactivityProvider";
import { ThemeProvider } from './ThemeContext';

const App = () => {
  return (
      <ThemeProvider>
        <div className="App">
          <NavigationProvider>
            <AppRoutes />
          </NavigationProvider>
        </div>
      </ThemeProvider>
  );
};

export default App;
